import { render, staticRenderFns } from "./ImageSudokuSetting.vue?vue&type=template&id=5216ed64&scoped=true"
import script from "./ImageSudokuSetting.vue?vue&type=script&lang=js"
export * from "./ImageSudokuSetting.vue?vue&type=script&lang=js"
import style0 from "./ImageSudokuSetting.vue?vue&type=style&index=0&id=5216ed64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216ed64",
  null
  
)

export default component.exports